// Manual intent is an explicit human decision, never evidence of coach eligibility.
export function manualRecipientIntent(championshipId,people){
 if(!Array.isArray(people)||!people.length||people.some(p=>!['entered','suggestion-override'].includes(p.manualChoice)))return null
 return {protocol:'manual-recipient-v1',championshipId:String(championshipId),acknowledgement:'unverified-business-addresses',entries:people.map(p=>({email:p.email.trim().toLowerCase(),choice:p.manualChoice,source:p.manualChoice==='suggestion-override'?p.suggestionSource:null}))}
}
export function suggestionSource(person,school,championshipId){
 const id=v=>typeof v==='string'&&/^[1-9]\d{0,19}$/.test(v)?v:null
 return {kind:'system-suggestion',contactId:id(person.contactId||person.id),companyId:id(school?.id),championshipId:String(championshipId)}
}
